import { useState } from 'react';
import { FormControl, Stack, FormLabel, Box } from '@chakra-ui/react';
import { Field } from 'formik';
import { usePartnerForm } from '../../hooks/usePartnerForm';
import NumberField from '@/components/forms/new/formikFormFields/NumberField';
import FieldToolTip from 'components/forms/new/FieldToolTip';
import { FORM_FIELD_PATHS } from '../../constants';
import {
    stackSpacing,
    formLabelStyling,
    stackStyling,
} from 'components/forms/new/formStyles';

const MinResourceAccountCount = ({ darkMode, errors }) => {
    const [isHovered, setIsHovered] = useState(false);
    const { formData, updateFormData } = usePartnerForm();

    const handleChange = (e) => {
        updateFormData(FORM_FIELD_PATHS.MIN_RESOURCE_ACCOUNT_COUNT, e.target.value);
    };
    
    const hasError = !!errors?.minBillableResourceAccounts;
    
    return (
        <FormControl
            sx={{ margin: '0 !important' }}
            isInvalid={hasError}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}>
            <Stack direction="row" spacing={stackSpacing} align="center" sx={stackStyling()}>
                <FormLabel sx={formLabelStyling(darkMode, true)} mb={0}>
                    Min Resource Account Count
                </FormLabel>
                <Box flex={1} maxWidth="400px">
                    <Field
                        component={NumberField}
                        id={FORM_FIELD_PATHS.MIN_RESOURCE_ACCOUNT_COUNT}
                        name={FORM_FIELD_PATHS.MIN_RESOURCE_ACCOUNT_COUNT}
                        noPadding
                        value={formData?.partnerBillingSettings?.minBillableResourceAccounts}
                        onChange={handleChange}
                        placeholder="Minimum resource account count"
                        width="110%"
                        darkMode={darkMode}
                        type="number"
                        min={0}
                    />
                </Box>
                {isHovered && (
                    <FieldToolTip
                        label="Minimum number of resource accounts to bill for"
                        ariaLabel="min-resource-account-count-tip"
                        left="25px"
                        top="5px"
                    />
                )}
            </Stack>
        </FormControl>
    );
};

export default MinResourceAccountCount;
